import { jsx, jsxs } from "react/jsx-runtime";
import { Image, Text } from "@wix/wix-ui-tpa/cssVars";
import { isExternalImage } from "../utils/drawer.js";
import styles from "./signature-image-wut.module.scss";
const SignatureImageWUT = ({
  id,
  value
}) => {
  if (!value || !isExternalImage(value)) {
    return null;
  }
  const image = value.url ? /* @__PURE__ */ jsx(
    "img",
    {
      id,
      src: value.url,
      alt: value.displayName,
      className: styles.externalImage,
      "data-hook": "signature-image"
    }
  ) : /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(Image, { className: styles.externalImageIcon, "data-hook": "signature-image" }),
    /* @__PURE__ */ jsx(Text, { id, children: value?.displayName })
  ] });
  return /* @__PURE__ */ jsx("div", { className: styles.container, children: image });
};
export {
  SignatureImageWUT
};
//# sourceMappingURL=signature-image-wut.js.map
